import {Log, LogActions, LogLevel} from './consts';
import {Transport} from './transports/Transport';
import {shouldLog} from './utils';

export class Logger implements Log, LogActions {
  private level: LogLevel;
  private name: string;
  private transports: Transport[] = [];

  constructor({
    name = '',
    level = 'debug',
    transports = [],
  }: {name?: string; level?: LogLevel; transports?: Transport[]}) {
    this.name = name;
    this.level = level;
    this.transports = transports;
  }

  use(transport: Transport) {
    this.transports.push(transport);
  }

  setLevel(level: LogLevel) {
    this.level = level;
  }

  log(level: LogLevel, message: string, ...args: unknown[]) {
    if (!shouldLog(level, this.level)) {
      return;
    }

    if (this.transports.length === 0) {
      return;
    }

    this.transports.forEach((transport) => {
      if (!transport.shouldLog(level)) {
        return;
      }

      transport.log(this.name, level, message, ...args);
    });
  }

  critical(message: string, ...args: unknown[]) {
    this.log('critical', message, ...args);
  }

  error(message: string, ...args: unknown[]) {
    this.log('error', message, ...args);
  }

  warn(message: string, ...args: unknown[]) {
    this.log('warn', message, ...args);
  }

  info(message: string, ...args: unknown[]) {
    this.log('info', message, ...args);
  }

  verbose(message: string, ...args: unknown[]) {
    this.log('verbose', message, ...args);
  }

  debug(message: string, ...args: unknown[]) {
    this.log('debug', message, ...args);
  }
}
